<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Assessment Analysis Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        @change="getStd()"
                        persistent-hint
                        hint="Please select academic year"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        dense
                        required
                        outlined
                        rounded
                        color="#0F2027"
                        v-model="sem"
                        :items="semester_list"
                        item-text="display_name"
                        item-value="id"
                        label="Semester"
                        persistent-hint
                        hint="Please select semester"
                        @click="putallnull()"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_std_data"
                        return-object
                        :items="std_div_list"
                        item-text="std"
                        label="Standard"
                        outlined
                        @change="
              getDiv();
              getassessmentschemedetails();
            "
                        persistent-hint
                        hint="Please select standard"
                        @click="putnull"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id" :items="div_list" item-text="div_name" label="Division" outlined persistent-hint hint="Please select division" />
                </v-col>
                <v-col cols="12" sm="5" md="5" v-if="assessment_detail_list != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="assessment_detail"
                        return-object
                        :items="assessment_detail_list"
                        item-text="ass_type_name"
                        label="Assessment Scheme Details"
                        outlined
                        persistent-hint
                        hint="Please select assessment scheme details"
                        @click="putnull3"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data && div && assessment_detail">
                    <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <!-- <v-row justify="center"> -->
        <span v-if="learner_course_list != null">
            <span v-if="show">
                <v-row>
                    <v-col cols="12" sm="3" md="3">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-btn class="no-display" rounded color="success" outlined @click="fnExcelReport('tab1', 'AllSubjectReport')" :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                    </v-col>
                </v-row>
                <div id="tab">
                    <center>
                        <table dense  class="elevation-1 table" style="width: 100%;">
                            <thead>
                                <tr>
                                    <!-- <th class="table" v-if="org_basic_data.trust_logo">
                                        <center>
                                            <img :src="org_basic_data.trust_logo" class="trust-logo"  />
                                        </center>
                                    </th> -->
                
                                        
                            <v-row>
                            <v-col cols="12" sm="2" md="2" align="center">
                                <img :src="org_basic_data.school_logo" class="print-logo" width="50%" alt="logo" />
                            </v-col>
                            <v-col cols="12" sm="8" md="8" align="center">
                                <h2 v-if="org_basic_data.trust_name" class="trust_name" >
                                    {{ org_basic_data.trust_name }}
                                </h2>
                                <h2 style="text-transform: uppercase;" v-if="org_basic_data.school_name" class="school_name">
                                    {{ org_basic_data.school_name }}</h2>
                                <h4 style="text-transform: uppercase;" class="scheme_name"> {{ ass_Scheme }} - {{ academicyear }} </h4>
                                <h4 class="report_name">Assessment Analysis Report</h4>
                               
                            </v-col>
                            <v-col cols="12" sm="2" md="2" align="center">
                                <img :src="org_basic_data.trust_logo" class="print-logo" width="50%" alt="logo" />
                            </v-col>
                        </v-row>
                           
                            
                                    <!-- <th class="table" v-if="org_basic_data.school_logo">
                                        <center>
                                            <img :src="org_basic_data.school_logo" alt="logo" class="schl-logo" />
                                        </center>
                                    </th> -->
                                </tr>
                                <tr>
                                    <th class="table" colspan="3">
                                        <v-row dense style="justify-content: space-evenly;">
                                            <span class="mr-5">
                                                <strong>
                                                    <h4>Class : {{ standard }} {{ division }}</h4>
                                                </strong>
                                            </span>
                                            <strong><h4>Exam : {{ ass_Scheme }}</h4></strong>
                                            <span class="ml-5" v-if="show_signature_column==true">
                                                <strong><h4>Class Teacher Name : _____________________________________</h4></strong>
                                            </span>
                                            
                                        </v-row>
                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </center>
                </div>
                <div id="tab1">
                    <div class="">
                        <v-simple-table fixed-header height="500px" dense class="elevation-1 scroll table-data">
                            <thead>
                                <tr>
                                    <th class="sticky-header"><center>Sr. No.</center></th>
                                    <th class="sticky-header"><center>Roll No.</center></th>
                                    <th class="sticky-header"><center>Registration No.</center></th>
                                    <th class="sticky-header"><center>Name</center></th>
                                    <th class="sticky-header" v-for="header in course_list" :key="header">
                                        <center>{{ header }}</center>
                                    </th>
                                    <th class="sticky-header"><center>Total</center></th>
                                    <th class="sticky-header"><center>%</center></th>
                                    <th class="sticky-header"><center>Grade</center></th>
                                    <th class="sticky-header" style="width: 250px;" v-if="show_signature_column==true"><center>Parents Sign</center></th>

                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll; border: 1px solid #ccc;">
                                <tr v-for="(s, index) in learner_course_list" :key="s.cid">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ s.rollno }}</td>
                                    <td>
                                        {{ s.registration_number }}
                                    </td>
                                    <td>{{ s.name }}</td>
                                    <td v-for="(header, index) in s.comp_marks" :key="index">
                                        <center>{{ header }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.levaluated_marks }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.converted_marks }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.grade }}</center>
                                    </td>
                                    <td v-if="show_signature_column==true">
                                        
                                    </td>
                                </tr>
                            </tbody>
                            
                        </v-simple-table>
                        <div style="background-color: white; margin-top: 100px;" v-if="show_signature_column==true">
                            <v-row dense style="justify-content: space-evenly;">
                                            <span class="mr-5">
                                                <strong>
                                                    Class Teacher
                                                </strong>
                                            </span>
                                            <span class="ml-5">
                                                <strong>
                                                   H.O.D
                                                </strong>
                                            </span>
                                            <span class="ml-5">
                                                <strong>
                                                    Principal
                                                </strong>
                                            </span>
                                </v-row>
                        </div>
                            
                    </div>
                </div>
            </span>
        </span>
    </div>
</template>
<script>
    import axios from "axios";
    import jsPDF from "jspdf";
    import "jspdf-autotable";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                overlay: false,
                selected: [],
                snackbar: false,
                course_list: [],
                crs_id: null,
                search: "",
                crs_list: [],
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                assessment_detail_list: [],
                assessment_detail: [],
                standard: null,
                division: null,
                course: null,
                ass_Scheme: null,
                academicyear: null,
                ass_detail_list: null,
                learner_course_list: null,
                inst_name: null,
                show: false,
                course_list: [],
                org_basic_data: [],
                default_value: null,
                show_signature_column: false,
            };
        },

        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
                const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const filename = name + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },

            putallnull() {
                this.div_list = null;
                (this.assessment_detail_list = []), (this.assessment_detail = null);
            },
            putnull3() {
                this.show = false;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putnull() {
                this.crs_list = [];
                this.crs_id = null;
            },
            putnull2() {
                (this.assessment_detail_list = []), (this.assessment_detail = null);
            },
            getassessmentschemedetails() {
                axios
                    .post("/Examination/getassesmentType")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.assessment_detail_list = res.data.assessment_type_list;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getreport() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    sem: this.sem,
                    div: this.div,
                    assessment_detail: this.assessment_detail.id,
                };
                this.fetch_loader = true;
                axios
                    .post("/SanjivaniExamination/getAssschemetAnalysisReport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.standard = res.data.standard;
                            this.division = res.data.div;
                            this.course = res.data.course;
                            this.ass_Scheme = res.data.ass_Scheme;
                            this.academicyear = res.data.ay;
                            this.learner_course_list = res.data.learner_course_list;
                            this.default_value = res.data.default_value;
                            if (this.default_value == "True") {
                                for (var i = 0; i < this.learner_course_list.length; i++) {
                                    this.learner_course_list[i].converted_marks = Math.round(this.learner_course_list[i].converted_marks);
                                    this.learner_course_list[i].levaluated_marks = Math.round(this.learner_course_list[i].levaluated_marks);
                                }
                            }
                            this.course_list = res.data.course_list;
                            this.inst_name = res.data.inst_name;
                            this.org_basic_data = res.data.org_basic_data;
                            this.fetch_loader = false;
                            this.show = true;
                            this.show_signature_column=res.data.show_signature_column;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
                            this.fetch_loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => {});
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = this.sel_std_data.div_list;
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.semester_list = res.data.sem_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
           
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .table {
        border: none !important;
    }
    .scroll {
        overflow-x: scroll;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .trust-logo {
            width: 10% !important;
            height: 10% !important;
        }
        .schl-logo {
            width: 8% !important;
            height: 8% !important;
        }

    .sticky-header {
        position: sticky;
        top: 0;
        z-index: 2;
        background: #fff;
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        /* img {
    width: 100% !important;
  } */
        .scroll {
            overflow-x: hidden;
        }
        body,
        tr,
        th,
        td {
            font-size: 14px !important;
            font-weight: bold !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        .trust-logo {
            width: 86%;
        }
        .schl-logo {
            width: 83%;
        }
        .trust_name{
            font-size: 30px;
        }
        .school_name{
            font-size: 40px;
        }
        .scheme_name{
            font-size: 20px;
        }
        .report_name{
            font-size: 20px;
        }

        @page {
            size: A3 landscape;
            
            margin: 5mm;
            /* padding: 0px; */
            /* size: 15.5in 15.5in; */
            /* size: 20in 15in; */
        }

        .table-data {
            height: 100% !important;
            overflow-x: hidden;
            overflow-y: visible !important;
        }

       ::v-deep .v-data-table__wrapper {
            height: auto !important;
            max-height: none !important;
            overflow: visible !important;
        }

        ::v-deep .sticky-header {
            position: static !important;
        }
    }
    /* .trust-logo {
  width: 41%;
} */
    .trust-logo {
        width: 86%;
    }
    .schl-logo {
        width: 83%;
    }
    .table-data {
        height: 500px;
    }
</style>
